import { LocalStore } from '../LocalStore/index';
import moment from 'moment'
moment.locale('vi');
export default class StaticClass {
    static configToast = {

        position: "top-right",
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,

    }
    static romanize = (num) => {
        var lookup = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 },
            roman = '',
            i;
        for (i in lookup) {
            while (num >= lookup[i]) {
                roman += i;
                num -= lookup[i];
            }
        }
        return roman;
    }
    static formatNumberFloat = (num) => {
        if (num) {
            return num.toFixed(2)
        }
        return 0;
    }
    static formatMoney = (n, c = ",") => {
        return Math.floor(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, c);
    }

    static permission = (...arg) => {
        return arg.includes(LocalStore.getInstance().read('loginPermission'));
    }
    static formatDate = (date) => {
        if(date && date.trim().length === 0){
            return ''
        }
        return date ? moment(date).format('L') : ''
    }

    static formatPrice(value, key = '.') { // format vnd
        if(!value) return value;
        value = value.toString();
        const decimalString = value.split('.')[1];
        value = value.split('.')[0];
        const result = value.replace(/\B(?=(\d{3})+(?!\d))/g, key);
        return decimalString ? result + "," + decimalString : result;
    }

}

